import React, {useEffect, useReducer} from "react";
import Html from "./html";
import { loadMessages} from "./service";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import FormSubmit from "./components/formSubmit";
import OffcanvasTemplate from "../../../common/offcanvasTemplate";
import CardWithHeaderTemplate from "../../../common/cardWithHeaderTemplate";

const Chat = ({
    show, 
    job_id, 
    job_firebase_document_id,
    handleClose,
    is_inbox,
    header, 
    emptyChat,
    is_have_selected_job
}) => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        if (!job_firebase_document_id) return;

        const unsubscribe = loadMessages(job_firebase_document_id, dispatch);

        return () => {
            unsubscribe && unsubscribe();
        };
    }, [job_firebase_document_id]);

    if(is_inbox){
        return (
            <Context.Provider value={{job_id, job_firebase_document_id, state, dispatch}}>
                <CardWithHeaderTemplate
                    header={header} 
                    body={is_have_selected_job ? <Html/> : emptyChat} 
                    footer= {
                        is_have_selected_job && <FormSubmit/>
                    }
                    extraCardClassName = {`blur shadow-blur max-height-vh-80 h-fix-100  min-height-vh-70`}
                    extraBodyClassName = {`overflow-auto overflow-x-hidden chat-body-height`}
                    showMy4={!is_inbox}
                />
            </Context.Provider>
        );
    }else{
        return(
            <Context.Provider value={{job_id, job_firebase_document_id, state, dispatch}}>
                <OffcanvasTemplate
                    open = {show}
                    handleClose = {() => handleClose()} 
                    placement = {'end'}  
                    title = {`JOB : #${job_id}`}
                    body = { <Html/>} 
                    footer = {<FormSubmit/>} 
                    style={{
                        top: '10%',
                        bottom : '10%', 
                        borderRadius: "5px",
                        right: '2%'
                    }}
                />
            </Context.Provider>
        )
    }
} 

export default Chat;